module.exports = __webpack_public_path__ + "images/avatars/female/16.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/16.png
// module id = OzWi
// module chunks = 153